export default __webpack_public_path__ + "static/media/bubbles-login.e40d9f0a.png";